import { render, staticRenderFns } from "./PrivacyInfoModal.vue?vue&type=template&id=97838d58"
import script from "./PrivacyInfoModal.vue?vue&type=script&lang=js"
export * from "./PrivacyInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports